import React, { useEffect, useRef } from "react";

import "./WriteBlogArticle.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import {
  fetch_articles,
  get_user,
  publish_article,
} from "../../network/communication";
import MDEditor from "@uiw/react-md-editor";
import CTAButton from "../../components/CTAButton/CTAButton";
import InfoPageHeader from "../../components/InfoPageHeader/InfoPageHeader";

function WriteBlogArticle(props) {
  const { section } = useParams("");
  const [content, setContent] = useState("");
  const navigate = useNavigate();
  const titleRef = useRef(null);
  const selectRef = useRef(null);

  const user = props.user;

  if (user && user.success === true && user.verified) {
    return (
      <main className="write-blog-main">
        <>
          <InfoPageHeader
            title="Write an Article"
            caption="Write and publish an article for the Quizzy Blog here"
          ></InfoPageHeader>
        </>
        <div className="main-section-header">
          <input
            type="text"
            className="setname"
            name="setname"
            placeholder="Enter the title of the article here"
            ref={titleRef}
          />
          <div className="desc" data-color-mode="light">
            <MDEditor
              textareaProps={{
                placeholder: "Write the entire article here",
              }}
              value={content}
              onChange={setContent}
            />
          </div>
          <p>Section</p>
          <select
            name="section"
            id="section"
            defaultValue={"getting_started"}
            ref={selectRef}
          >
            <option value="product_updates">Product Updates</option>
            <option value="study_tips">Study Tips</option>
            <option value="educational-research">Educational Research</option>
            <option value="collaborative_learning">
              Collaborative Learning
            </option>
            <option value="user_spotlight">User Spotlight</option>
          </select>

          <CTAButton
            text="Publish"
            color="pink"
            onClick={() => {
              publish_article(
                titleRef.current.value,
                content,
                selectRef.current.value,
                null,
                (data) => {
                  navigate(
                    "/blog/sections/" +
                      selectRef.current.value.replace("_", "-").toLowerCase() +
                      "/" +
                      data.id +
                      "/" +
                      titleRef.current.value.replace(/\s+/g, "-").toLowerCase()
                  );
                  console.log(data);
                }
              );
            }}
          ></CTAButton>
        </div>
      </main>
    );
  } else {
    return (
      <main className="write-support-main">
        <>
          <InfoPageHeader
            title="Access Denied"
            caption="You are not allowed to access this page."
          ></InfoPageHeader>
        </>
      </main>
    );
  }
}

export default WriteBlogArticle;
